import { useEffect, useState } from 'react';
import './ProjectsContent.css';
import { getProjects } from '../../utilities/api/projectsTimeline';
import ProjectsItem from '../../components/ProjectsItem/ProjectsItem';
import { dateSort, projNumSort } from '../../utilities/services/sortConditionally';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

export default function ProjectsContent({ user, isMobile, services }) {
  const [loading, setLoading] = useState(false)
  const [projects, setProjects] = useState([])
  const [sortOrder, setSortOrder] = useState('desc')
  const [sortHeader, setSortHeader] = useState('clientNumber')

  const getProjectsTimeline = async () => {
    setLoading(true)
    try {
      const allProjects = await getProjects(user)
      // convert the client number to an integer for sorting
      allProjects.forEach(project => {
        project.clientNumber = project.clientNumber ? parseInt(project.clientNumber) : ''
      })
      setProjects(allProjects.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1))
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }


  const handleTableHeaderClick = (evt) => {
    const header = evt.target.id;
    const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    setSortHeader(header);
    setSortOrder(newSortOrder);

    let sortedProjects = [...projects];
    if (header === 'projNum') {
        sortedProjects = projNumSort(newSortOrder, header, sortedProjects);
    } else if (['submissionDate', 'dueDate', 'clientDeadline'].includes(header)) {
        sortedProjects = dateSort(newSortOrder, header, sortedProjects);
    } else {
        sortedProjects.sort((a, b) => {
          if (newSortOrder === 'asc') {
            return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
          } else {
            return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
          }
        });
    }
    setProjects(sortedProjects);
  };

  useEffect(() => {
    getProjectsTimeline()
    // eslint-disable-next-line
  }, [])

  return (
    <div className='ProjectsContent'>
      <div className='projectsHeadingContainer'>
        <div className='headerContent'>
          <img src='https://project-intake-assets.s3.ca-central-1.amazonaws.com/Skin.png' alt="" />
          <div className='mainHeaderContent'>
              <div className='companyName'>
                  {capitalizeFirstLetter(user.companyName)}
              </div>
              <div className='instructions'>
                Below is a list of all <strong>projects</strong> associated with your account. Please reach out to us if you have any questions or concerns regarding a project.
              </div>
          </div>
        </div>
      </div>
      { loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
        <div><strong>Fetching most recent data</strong>...</div>
      </div>
      :
      <div className='projectsMainSection'>
        { (projects && projects.length > 0) ?
        <>
        <div className='header'>
          <div className='title'>
            Project List
          </div>
        </div>
        <div className='projectsTable'>
          <table className=''>
            <>
            <thead>
              <tr>
                <th id='projNum' onClick={handleTableHeaderClick} className='projNum' title='Click to sort by project number'>
                  <div className='tableHeaderWithArrow'><div>Project Number&nbsp;&nbsp;</div>
                  { sortHeader==='projNum'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                <th id='projType' onClick={handleTableHeaderClick} className='projType' title='Click to sort by service'>
                  <div className='tableHeaderWithArrow'><div>Service&nbsp;&nbsp;</div>
                  { sortHeader==='projType'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                <th id='projTitle' className='projTitle'>
                  <div className='tableHeaderWithArrow'>Title</div>
                </th>
                <th id='clientDeadline' onClick={handleTableHeaderClick} className='clientDeadline' title='Click to sort by due date'>
                  <div className='tableHeaderWithArrow clientDeadline'><div>Client Deadline&nbsp;&nbsp;</div>
                  { sortHeader==='clientDeadline'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                <th id='projectStatus' onClick={handleTableHeaderClick} title='Click to sort by project status'>
                  <div className='tableHeaderWithArrow'><div>Project Status&nbsp;&nbsp;</div>
                  { sortHeader==='projectStatus'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                <th id='projectReportLink'>
                  <div>Report Link</div>
                </th>
                <th id='otherLinks'>
                  <div>Other Links</div>
                </th>
              </tr>
            </thead>
            <tbody>
              { projects.length === 0 ?
              <tr>
                <td colSpan='12' className='noProjects text-center'>No Projects Found</td>
              </tr>
              :
              <>
              {projects.map(project => (
                <ProjectsItem user={user} key={project._id} projectItem={project} isMobile={isMobile} getProjects={getProjectsTimeline} services={services} />
              ))}
              </>
              }
            </tbody>
            </>
          </table>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
        </>
        :
        <div className='noProjects'>
          <div className='text-center'>
            <h4 className='errorText pt-5'>No Projects Available.</h4>
          </div>
        </div>
        }
      </div>
      }
    </div>
  )
}
